export enum CheckinReleaseTypes {
  LOAD_REQUEST = "@checkinRelease/LOAD_REQUEST",
  LOAD_SUCCESS = "@checkinRelease/LOAD_SUCCESS",
  LOAD_FAILURE = "@checkinRelease/LOAD_FAILURE",

  RELEASE_CHECKIN_REQUEST = "@checkinRelease/RELEASE_CHECKIN_REQUEST",
}

export interface CheckinReleaseParams {
  limit: number;
  page: number;
}

export interface CheckinReleasePayload {
  id: string;
  observation: string | null;
}

export interface CheckinReleaseList {
  id: string;
  _id: string;
  external_attendance_id: string;
  patient_id: {
    name: string;
  };
  // origin: string;
  created_at: string;
}

export interface CheckinReleaseState {
  data: CheckinReleaseList[];
  loading: boolean;
  success: boolean;
  error: boolean;
}
